export default __webpack_public_path__ + "static/media/andrei-rykov.db17418c.png";